import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { restartableTask, timeout } from 'ember-concurrency';
import zft from 'garaje/utils/zero-for-tests';

import { PAGE_SIZE, type VisitorsProfilesRouteModel } from './route';

const DEBOUNCE_TIME = zft(300);

export default class VisitorProfilesIndexController extends Controller {
  declare model: VisitorsProfilesRouteModel;

  queryParams = ['page', 'displayName'];
  @tracked page = 1;
  @tracked displayName = ''; // this is the actual debounced filter being used
  @tracked displayNameLive = this.displayName; // this is the live value for the search input

  @tracked directoryIsLoading: boolean = false;

  @action
  setPageNumber(pageNumber: number): void {
    this.directoryIsLoading = true;
    this.page = pageNumber;
  }

  @action
  onSearchInput(value: string): void {
    value = value.slice(0, 100); // limit to 100 characters
    this.displayNameLive = value;
    void this.setDisplayNameTask.perform(value);
  }

  setDisplayNameTask = restartableTask(async (query: string) => {
    await timeout(DEBOUNCE_TIME); // debounce search
    if (this.displayName !== query) {
      this.directoryIsLoading = true;
      this.displayName = query;
      this.page = 1;
    } else {
      this.directoryIsLoading = false;
    }
  });

  @action
  clearSearch(): void {
    void this.setDisplayNameTask.cancelAll();
    this.page = 1;
    this.directoryIsLoading = true;
    this.displayName = '';
    this.displayNameLive = '';
  }

  get pageCount(): number {
    return Math.ceil(this.model.visitorProfileCount / PAGE_SIZE);
  }

  get pageSize(): number {
    return PAGE_SIZE;
  }

  get pageNumber(): number {
    return this.page;
  }

  get hasProfiles(): boolean {
    return this.model.visitorProfileCount > 0;
  }
}
